import { render, staticRenderFns } from "./EvolveGoal.vue?vue&type=template&id=6d6be89d"
import script from "./EvolveGoal.vue?vue&type=script&lang=js"
export * from "./EvolveGoal.vue?vue&type=script&lang=js"
import style0 from "./EvolveGoal.vue?vue&type=style&index=0&id=6d6be89d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports